import React from 'react'
export function InterstitialButtonIcon({
  iconPath,
}: {
  readonly iconPath: string
}) {
  return (
    <img alt={''} aria-hidden={'true'} height={24} src={iconPath} width={24} />
  )
}
